import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Icon, Text, theme } from '@socrait/react';

import iKeepSafePng from './assets/iks_ferpa.png';

import { setupStepStyles } from './setupStepStyles';

export const FERPAStep = () => {
  return (
    <View style={setupStepStyles.container}>
      <Text style={setupStepStyles.headerText}>FERPA Safe</Text>
      <View style={setupStepStyles.contentContainer}>
        <img src={iKeepSafePng} style={styles.image} alt="iKeepSafe" />
        <View style={styles.privacyContainer}>
          <View style={styles.privacyItem}>
            <Icon style={styles.privacyIcon} type="checkedCircle" />
            <Text style={styles.text}>
              We're committed to privacy and security, especially keeping FERPA data safe, secure, and private.
            </Text>
          </View>
          <View style={styles.privacyItem}>
            <Icon style={styles.privacyIcon} type="checkedCircle" />
            <Text style={styles.text}>
              We also sign DPAs and adhere to all applicable state student data privacy laws.
            </Text>
          </View>
          <View style={styles.privacyItem}>
            <Icon style={styles.privacyIcon} type="checkedCircle" />
            <Text style={styles.text}>We follow the AI SAFE principles and are a member of EdSafe AI Alliance.</Text>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  image: {
    height: 126,
    width: '100%',
    objectFit: 'contain',
  },
  privacyContainer: {
    flex: 1,
    gap: theme.spacing.xlarge,
    paddingHorizontal: theme.spacing.large,
  },
  privacyItem: {
    flexDirection: 'row',
    gap: theme.spacing.large,
    width: '100%',
  },
  privacyIcon: {
    marginTop: theme.spacing.small,
  },
  text: {
    fontSize: theme.fontSizes.medium,
    lineHeight: theme.lineHeights.regular,
    flex: 1,
  },
});
